import React, { useRef, useEffect } from 'react';
import {FaTimes} from 'react-icons/fa';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    className?: string;
    children: React.ReactNode;
    showCloseButton?: boolean;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, className,  showCloseButton = true }) => {
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div data-dialog-backdrop='dialog' data-dialog-backdrop-close='true' className='absolute left-0 top-0 inset-0 z-[999] grid h-screen w-screen place-items-center bg-black bg-opacity-60 backdrop-blur-sm transition-opacity duration-300'>
            <div data-dialog='dialog' className='relative mx-auto flex w-full max-w-[64rem] flex-col rounded-xl bg-white bg-clip-border text-slate-700 shadow-md'>
                <div ref={modalRef} className={`${className}`} onClick={(e) => e.stopPropagation()}>
                    {showCloseButton && (
                        <button onClick={onClose} className='absolute right-3 top-3 z-999 flex h-9.5 w-9.5 items-center justify-center rounded-full bg-gray-100 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-700 sm:right-6 sm:top-6 sm:h-11 sm:w-11'>
                            <FaTimes />
                        </button>
                    )}
                    <div>{children}</div>
                </div>
            </div>
        </div>
    );
};